import { Component } from '@angular/core';

@Component({
  selector: 'app-total-users-svg',
  standalone: true,
  template: `<svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#CEEAFC" />
    <mask
      id="mask0_8865_1705"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="4"
      y="3"
      width="16"
      height="17"
    >
      <rect x="4" y="3.3418" width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_8865_1705)">
      <path
        d="M12 11.1363C11.3583 11.1363 10.809 10.9079 10.3521 10.4509C9.89514 9.994 9.66667 9.4447 9.66667 8.80304C9.66667 8.16138 9.89514 7.61208 10.3521 7.15514C10.809 6.6982 11.3583 6.46973 12 6.46973C12.6416 6.46973 13.1909 6.6982 13.6479 7.15514C14.1048 7.61208 14.3333 8.16138 14.3333 8.80304C14.3333 9.4447 14.1048 9.994 13.6479 10.4509C13.1909 10.9079 12.6416 11.1363 12 11.1363ZM7 16.2133V14.7312C7 14.4047 7.08868 14.1024 7.26603 13.8242C7.44338 13.546 7.68034 13.3321 7.97692 13.1825C8.63589 12.8594 9.30064 12.6171 9.97115 12.4556C10.6417 12.2941 11.3179 12.2133 12 12.2133C12.682 12.2133 13.3583 12.2941 14.0288 12.4556C14.6993 12.6171 15.3641 12.8594 16.023 13.1825C16.3196 13.3321 16.5566 13.546 16.7339 13.8242C16.9113 14.1024 17 14.4047 17 14.7312V16.2133H7Z"
        fill="#0059D5"
      />
    </g>
  </svg> `,
})
export class TotalUsersSvgComponent {}
